import { ImageListType } from 'react-images-uploading'
import { assert } from '~/lib/customAssert'
import { IMAGE_HOST } from './config'
import { logger } from './logger'

type CreateConvertImagesType = (
  | {
      image?: File
    }
  | {
      imageUrl?: string
    }
)[]

/**
 * 画像アップロード
 * 画像を新しいアップロードする場合は、Fileを返す
 * 既存の画像を使う場合は、画像URLをそのまま帰す
 */
export async function createImage(imageList: ImageListType): Promise<CreateConvertImagesType> {
  const images = await Promise.all(
    imageList.map(async (image) => {
      if (!image.dataURL) return undefined

      if (image.dataURL.startsWith(IMAGE_HOST)) {
        return image.dataURL
      } else {
        const fileName = image.file?.name.slice(0, 200)
        if (!fileName) return undefined
        try {
          const response = await fetch(image.dataURL)

          if (!response.ok) {
            throw new Error('Failed to fetch image')
          }

          const blob = await response.blob()
          const fileType = fileName.split('.').pop()

          return new File([blob], fileName, { type: fileType })
        } catch (error) {
          logger.error(new Error('Failed to fetch image', { cause: error }))
        }
      }
    }),
  )

  const uploadImages = images.map((image) => {
    assert(image)
    if (typeof image === 'string') {
      return {
        imageUrl: image,
      }
    } else {
      return {
        image,
      }
    }
  })

  return uploadImages
}
